const env = {
  // PRD -> https://eva.pefisa.com.br/api/ceaportal
  apiUrl: 'https://eva.pefisa.com.br/api/ceaportal',
  language: 'pt',
};

export default env;
